import {
  UserStore,
  AdvisorsStore,
  OrganizationsStore,
  SettingsStore,
  ManagersStore,
  TiersStore,
  BillingStore,
  ReauthChallengeStore,
  ActivityLogStore,
  UsersStore,
} from './pages';
import { HistoryStore } from './data';

export const store = {
  historyStore: new HistoryStore(),
  userStore: new UserStore(),
  advisorStore: new AdvisorsStore(),
  organizationStore: new OrganizationsStore(),
  settingsStore: new SettingsStore(),
  managersStore: new ManagersStore(),
  tiersStore: new TiersStore(),
  billingStore: new BillingStore(),
  reauthChallengeStore: new ReauthChallengeStore(),
  activityLogStore: new ActivityLogStore(),
  usersStore: new UsersStore(),
};
export type IStore = typeof store;

export * from './pages/defaults';